import React from "react";
import ComparisonDetailItem from "./ComparisonDetailItem";
import { BenefitItemProps } from "../../../@types";
import { getBenefitCost, useTranslate } from "../../../helpers";

const ComparisonBenefitItem: React.FunctionComponent<BenefitItemProps> = ({
  label,
  plan,
  mobileLabelOnly,
  ...bscProps
}) => {
  const t = useTranslate();
  return (
    <ComparisonDetailItem
      mobileLabelOnly={mobileLabelOnly}
      label={label}
      detail={getBenefitCost(t, { ...bscProps, plan })}
      {...bscProps}
    />
  );
};

export default ComparisonBenefitItem;
